// localStorage keys
const AUTH_STORAGE_KEY = 'digikool_auth'
const AUTH_TIMESTAMP_KEY = 'digikool_auth_timestamp'
const AUTH_CACHE_DURATION = 5 * 60 * 1000 // 5 minutes in milliseconds

// Helper functions for localStorage
const saveToLocalStorage = (data) => {
  if (process.client) {
    try {
      localStorage.setItem(AUTH_STORAGE_KEY, JSON.stringify(data))
      localStorage.setItem(AUTH_TIMESTAMP_KEY, Date.now().toString())
    } catch (error) {
      // Failed to save auth to localStorage
    }
  }
}

const loadFromLocalStorage = () => {
  if (process.client) {
    try {
      const authData = localStorage.getItem(AUTH_STORAGE_KEY)
      const timestamp = localStorage.getItem(AUTH_TIMESTAMP_KEY)
      
      if (authData && timestamp) {
        const age = Date.now() - parseInt(timestamp, 10)
        // If data is older than cache duration, consider it stale
        if (age < AUTH_CACHE_DURATION) {
          return JSON.parse(authData)
        } else {
          // Clear stale data
          clearLocalStorage()
        }
      }
    } catch (error) {
      clearLocalStorage()
    }
  }
  return null
}

const clearLocalStorage = () => {
  if (process.client) {
    try {
      localStorage.removeItem(AUTH_STORAGE_KEY)
      localStorage.removeItem(AUTH_TIMESTAMP_KEY)
    } catch (error) {
      // Failed to clear auth from localStorage
    }
  }
}

export const state = () => {
  // Initialize state from localStorage if available
  const cachedAuth = loadFromLocalStorage()
  return {
    isAuthenticated: cachedAuth?.isAuthenticated || false,
    user: cachedAuth?.user || null
  }
}

export const getters = {
  isLoggedIn: (state) => state.isAuthenticated,
  currentUser: (state) => state.user
}

export const mutations = {
  setAuth(state, { isAuthenticated, user }) {
    state.isAuthenticated = isAuthenticated
    state.user = user
    // Save to localStorage
    saveToLocalStorage({ isAuthenticated, user })
  },

  clearAuth(state) {
    state.isAuthenticated = false
    state.user = null
    // Clear localStorage
    clearLocalStorage()
  },

  updateUser(state, userData) {
    if (state.user) {
      state.user = { ...state.user, ...userData }
      // Update localStorage
      saveToLocalStorage({ isAuthenticated: state.isAuthenticated, user: state.user })
    }
  }
}

export const actions = {
  async checkAuthStatus({ commit, state, dispatch }, { forceRefresh = false } = {}) {
    // Check localStorage first (unless force refresh is requested)
    if (!forceRefresh && state.isAuthenticated && state.user) {
      return true
    }

    try {
      const response = await this.$axios.get('/user/me')
      // Check if user is authenticated (response.data.authenticated === true)
      if (response.data && response.data.authenticated === true) {
        commit('setAuth', {
          isAuthenticated: true,
          user: response.data
        })
        return true
      }
      commit('clearAuth')
      return false
    } catch (error) {
      // If API call fails but we have cached data, use it (might be network issue)
      if (state.isAuthenticated && state.user) {
        return true
      }
      commit('clearAuth')
      return false
    }
  },
  
  // Force refresh from server
  async refreshAuthStatus({ commit, dispatch }) {
    return dispatch('checkAuthStatus', { forceRefresh: true })
  }
}

